import React, {Component} from 'react'
import _ from 'lodash'

import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  Typography,
} from 'material-ui'

import {
  Link,
} from 'react-router-dom'

// import {
//   Login,
// } from '../helper/functions'

import {
  bgWhite,
  Accent,
} from '../helper/consts'

import Logo from '../img/logo.png'

const style = {
  section:{
    background:'radial-gradient(ellipse 100% 100% at 90% 90%, #9271f6, #3f51b5)',
    minWidth: '100vw',
    margin:0,
    position:'relative',
    overflow:'hidden',
    flexDirection:'row',
    right: 0,
    display: 'flex',
    maxHeight: 'calc(100vh - 64px)',
    justifyContent: 'flex-end',
  },
  rivers:{
    height:'100%',
    display: 'flex',
  },
  riverFarLeft:{
    left: '-470px',
  },
  riverLeft:{
    left: '-300px',
  },
  riverCenter:{
    left: '-130px',
  },
  ctaContainer:{
    right: '0',
    zIndex: '3',
    minWidth: '310px',
    width:'33%',
    height: '100%',
    opacity: '1',
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
    position: 'relative',
  },
  ctaMessage:{
    display: 'flex',
    flexWrap: 'wrap',
    maxWidth: '320px',
    lineHeight: '110%',
    marginBottom: '25px',
    fontWeight: '800',
    color:bgWhite,
  },
  ctas:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  ctaBtn:{
    marginRight: '21px',
    boxShadow: `0px 10px 50px -5px ${Accent}`,
    minWidth: '150px',
    minHeight: '50px',
    borderRadius: '50px',
  },
}

export default class LandingPageHeader extends Component{
  constructor(props){
    super(props);
    this.state = {
      cards:[
        {
          avatar:Logo,
          name:'Allan Hughes',
          email:'allan@uneau.com',
          title:'Check it out!',
          message:"This is a great opportunity! Consider applying, you would be great!",
        },
        {
          avatar:Logo,
          name:'Brian Hughes',
          email:'brian@uneau.com',
          title:'Have a look!',
          message:"This is perfect for you. Let me know if you want some more info, I have some contacts there!",
        },
        {
          avatar:Logo,
          name:'Chris Hughes',
          email:'chris@uneau.com',
          title:'Perfect!',
          message:"You would rock at this! This position has your name all over it!",
        },
        {
          avatar:Logo,
          name:'David Hughes',
          email:'david@uneau.com',
          title:'OMG!',
          message:"Have you seen this?!? This is your dream job and you would be perfect!",
        },
        {
          avatar:Logo,
          name:'Ewen Hughes',
          email:'ewen@uneau.com',
          title:'You would be amazing for this role!',
          message:"This is an incredible opportunity and it sounds like you would be a shoe-in. You should apply!",
        },
        {
          avatar:Logo,
          name:'Jeff Hughes',
          email:'jeff@uneau.com',
          title:'Look!',
          message:"I'm sure you've seen this, but if not then check it out now! You're the ideal candidate!",
        },
      ]
    }
  }

  renderCards=()=>{
    let html = [];
    let {cards} = this.state;
    _.shuffle(cards).forEach(user=>{
      let card = (
        <Card key={user.name} className="landingPageCard" >
          <CardHeader
            avatar={
              <Avatar
              alt={user.name}
              src={user.avatar}
              aria-label={document.title}
              />
            }
            title={user.name}
            subheader={user.email}
          />
          <CardContent>
            <Typography type="title">{user.title}</Typography>
            <Typography type="body1">{user.message}</Typography>
          </CardContent>
          <Divider light />
          <CardActions>
            <Button disableRipple disableFocusRipple raised color="primary">Share</Button>
            <Button disableRipple disableFocusRipple raised color="primary">Apply</Button>
          </CardActions>
        </Card>
      )
      html.push(card);
    })
    return html;
  }

  render(){
    return(
      <section style={style.section} className="loggedOutBody">
        <div style={style.rivers}>
          <div style={style.riverFarLeft} id="riverLeft" className="river">
            {this.renderCards()}
          </div>
          <div style={style.riverLeft} id="riverCenter" className="river">
            {this.renderCards()}
          </div>
          <div style={style.riverCenter} id="riverRight" className="river">
            {this.renderCards()}
          </div>
        </div>
        <div style={style.ctaContainer}>
          <div className="cta">
            <Typography style={style.ctaMessage} type={"display2"}>Network Recruitment</Typography>
            <Typography style={style.ctaMessage} type={"subheading"}>Make a Lasting Connection.</Typography>
            <div style={style.ctas}>
              <Link
                to={{
                  pathname: '/Join',
                  state: { tab: 'signUp' }
                }}
              >
                <Button style={style.ctaBtn} raised color='accent' >Sign Up</Button>
              </Link>
              <Link to={'/About'}><Button color="contrast">Learn More ></Button></Link>
            </div>
          </div>
          <div className="space"></div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LandingPageHeader.js